import { Scale } from "lucide-react";
import type { ClauseSearchResult } from "./chatCardUtils";

interface ClauseCardProps {
  data: ClauseSearchResult;
}

export function ClauseCard({ data }: ClauseCardProps) {
  return (
    <div className="mt-2 space-y-2">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5 text-[11px] font-medium text-muted uppercase tracking-wider">
          <Scale size={12} />
          <span>{data.standardName}</span>
        </div>
        <span className="text-[10px] text-muted">
          {data.totalClauses} clause{data.totalClauses !== 1 ? "s" : ""}
        </span>
      </div>

      {/* Sections */}
      <div className="space-y-2">
        {data.sections.map((section) => (
          <div
            key={section.title}
            className="rounded-lg border border-border/40 bg-card p-2 space-y-1.5"
          >
            <span className="text-xs font-medium text-primary">
              {section.title}
            </span>
            <div className="space-y-1">
              {section.clauses.map((clause) => (
                <div
                  key={clause.ref}
                  className="flex items-start gap-2 border-l-2 border-orange-400/60 pl-2"
                >
                  <span className="shrink-0 text-[10px] font-mono font-semibold text-orange-400 bg-orange-400/10 rounded px-1.5 py-0.5">
                    {clause.ref}
                  </span>
                  <div className="min-w-0">
                    <span className="text-[11px] font-medium text-primary">
                      {clause.title}
                    </span>
                    {clause.description && (
                      <p className="text-[10px] text-muted line-clamp-2 mt-0.5">
                        {clause.description}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
